"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit");

require("../styles/_total-summary.scss");

function TotalSummary(a) {
  var b = a.total,
      c = a.currencySymbol;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", {
    className: "total-summary"
  }, _react["default"].createElement("hr", null), _react["default"].createElement("div", {
    className: "total-summary__content"
  }, _react["default"].createElement(_uiKit.Text, {
    noMargin: !0
  }, "Sub-Total"), _react["default"].createElement(_uiKit.Text, {
    noMargin: !0,
    highlighted: !0
  }, "".concat(c).concat(b)))));
}

var _default = (0, _react.memo)(TotalSummary);

exports["default"] = _default;